
export class SubmitContributorData {
    caseActionSK: string;
    personSK: string;
    iepFormSK: string
    sectionId: string;
    role: number;
    iepSection: number;
    lastModuser: string;
    lastModTS: Date;
    personName: string;
    firstName: string; 
    lastName: string; 
    middleName: string; 
    email: string; 
    phone: string; 
    title: string; 
    operationType: number;
    constructor(contributorData: any) {
        this.caseActionSK = contributorData.iepFormSk;
        this.iepFormSK = contributorData.iepFormSk;
        this.sectionId = contributorData.sectionId;
        this.personSK = contributorData.personSk;
        this.role = contributorData.role;
        this.iepSection = contributorData.sectionId;
        this.lastModuser = contributorData.lastModuser;
        this.lastModTS = contributorData.lastModTS;
        this.personName = contributorData.personName;
        this.firstName = contributorData.firstName;
        this.lastName = contributorData.lastName;
        this.middleName = contributorData.middleName;
        this.email = contributorData.email;
        this.phone = contributorData.phone;
        this.title = contributorData.title;
        this.operationType = contributorData.operationType;
    }
    get id(): string {
        return this.caseActionSK
    }
}
